module.exports = {
  renderer: [ 'type', require(43) ],
  styles: [ 'type', require(44) ]
};